import React, { useEffect, useState } from "react";
import DatePicker, { registerLocale } from 'react-datepicker'
import ContentHeader from '../../components/ContentHeader'
import Loader from "../../components/Loader";
import Swal from "sweetalert2";
import axios from "axios";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
import 'react-datepicker/dist/react-datepicker.css'
import es from "date-fns/locale/es";

registerLocale('es', es);

const DriverBinnacle = () => {
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState(new Date());
    const [times, setTimes] = useState([]);
    const [time, setTime] = useState('');
    const [binnacles, setBinnacles] = useState([]);
    const [driverId, setDriverId] = useState(null);
    const [driverName, setDriverName] = useState('');
    const [selectedSchedule, setSelectedSchedule] = useState(null);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        // Obtener el driver_id del usuario desde localStorage
        const userData = localStorage.getItem('dataUser');
        if (userData) {
            const user = JSON.parse(userData);
            setDriverId(user.driver_id);
            // Obtener el nombre del conductor
            getDriverName(user.driver_id);
        }

        // Inicializar DataTable
        var table = $('.main').DataTable();
        table.destroy();
        setTimeout(() => {
            $('.main').DataTable({
                searching: true,
                destroy: true,
                retrieve: true,
                pageLength: 50,
                responsive: true,
                autoWidth: true,
                paging: true,
                ordering: true,
                sortable: true,
                processing: false,
                serverSide: false,
                bInfo: true,
                language: {
                    "decimal": "",
                    "emptyTable": "No hay viajes asignados para esta fecha y horario",
                    "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                    "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                    "infoPostFix": "",
                    "thousands": ",",
                    "lengthMenu": "Mostrar _MENU_ registros",
                    "loadingRecords": "Cargando...",
                    "processing": "Procesando...",
                    "search": "Buscar:",
                    "paginate": {
                        "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                        "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                        "next": "<i class='fas fa-arrow-circle-right'></i>",
                        "previous": "<i class='fas fa-arrow-circle-left'></i>"
                    },
                    "zeroRecords": "No hay viajes asignados",
                    "searchPlaceholder": "Buscar...",
                },
            });
            setLoading(false);
        }, 100);
    }, []);

    useEffect(() => {
        // Configurar evento para el select2 del tiempo
        $('#time').on("change", function (e) {
            const selectedValue = e.target.value;
            console.log('Tiempo seleccionado:', selectedValue);
            setTime(selectedValue);
            
            // Encontrar el schedule completo basado en el valor seleccionado
            const selectedTimeData = times.find(item => item.value === selectedValue);
            console.log('Datos del tiempo seleccionado:', selectedTimeData);
            if (selectedTimeData) {
                setSelectedSchedule({
                    schedule_id: selectedTimeData.schedule_id,
                    branch_id: selectedTimeData.branch_id
                });
            } else {
                setSelectedSchedule(null);
            }
        });
    }, [times]);

    useEffect(() => {
        // Obtener horarios cuando cambie la fecha o se tenga el driverId
        if (driverId) {
            getDriverSchedulesDay();
        }
    }, [date, driverId]);

    const getDriverName = async (driverId) => {
        try {
            const form = new FormData();
            form.append('driver_id', driverId);
            const response = await axios.post(ENDPOINT + 'get-driver-name', form);
            if (response.data.res) {
                setDriverName(response.data.data.name);
            }
        } catch (error) {
            console.error('Error al obtener nombre del conductor:', error);
        }
    };

    const handleCalendarClose = () => {
        if (driverId) {
            getDriverSchedulesDay();
        }
    };

    const getDriverSchedulesDay = async () => {
        if (!driverId) {
            Swal.fire({
                icon: 'warning',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">No se pudo identificar al conductor. Por favor, inicie sesión nuevamente.</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
            return;
        }

        setLoading(true);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const dateFormat = year + '-' + month + '-' + day;
        
        const form = new FormData();
        form.append('date', dateFormat);
        form.append('driver_id', driverId);
        
        try {
            const response = await axios.post(ENDPOINT + 'get-driver-schedules-day', form);
            const timeArray = response.data.data.map(function (element) {
                return {
                    label: element.display_text || element.time,
                    value: element.time,
                    schedule_id: element.schedule_id,
                    branch_id: element.branch_id,
                    branch_name: element.branch_name
                };
            });
            setTimes(timeArray);
        } catch (error) {
            console.error('Error al obtener horarios:', error);
            setTimes([]);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Error al cargar los horarios asignados</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
        }
        setLoading(false);
    };

    const handleSearch = async () => {
        if (!driverId) {
            Swal.fire({
                icon: 'warning',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">No se pudo identificar al conductor. Por favor, inicie sesión nuevamente.</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
            return;
        }

        if (!time || !selectedSchedule) {
            Swal.fire({
                icon: 'warning',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Por favor, seleccione fecha y hora</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
            return;
        }

        console.log('Buscando con:', {
            time: time,
            schedule_id: selectedSchedule.schedule_id,
            branch_id: selectedSchedule.branch_id
        });

        const form = new FormData();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const dateFormat = year + '-' + month + '-' + day;
        
        form.append('date', dateFormat);
        form.append('time', time);
        form.append('driver_id', driverId);
        form.append('schedule_id', selectedSchedule.schedule_id);
        form.append('branch_id', selectedSchedule.branch_id);
        
        setLoading(true);
        await axios.post(ENDPOINT + 'search-driver-binnacle', form).then(response => {
            setLoading(false);
            setBinnacles(response.data.data);
            
            var table = $('.main').DataTable();
            table.destroy();
            setTimeout(() => {
                $('.main').DataTable({
                    searching: true,
                    destroy: true,
                    retrieve: true,
                    pageLength: 50,
                    responsive: false,
                    autoWidth: true,
                    paging: true,
                    ordering: true,
                    sortable: true,
                    processing: false,
                    serverSide: false,
                    bInfo: true,
                    language: {
                        "decimal": "",
                        "emptyTable": "No hay viajes asignados para esta fecha y horario",
                        "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                        "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                        "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                        "infoPostFix": "",
                        "thousands": ",",
                        "lengthMenu": "Mostrar _MENU_ registros",
                        "loadingRecords": "Cargando...",
                        "processing": "Procesando...",
                        "search": "Buscar:",
                        "paginate": {
                            "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                            "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                            "next": "<i class='fas fa-arrow-circle-right'></i>",
                            "previous": "<i class='fas fa-arrow-circle-left'></i>"
                        },
                        "zeroRecords": "No hay viajes asignados",
                        "searchPlaceholder": "Buscar...",
                    },
                });
            }, 100);
        }).catch(function (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + (error.response?.data?.msg || 'Error en la búsqueda') + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
        });
    };

    const resetPage = () => {
        window.location.reload();
    };

    const handlePrint = async () => {
        if (!driverId || !time || !selectedSchedule) {
            Swal.fire({
                icon: 'warning',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Por favor, seleccione fecha y hora</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
            return;
        }

        setLoading(true);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const date_send = year + '-' + month + '-' + day;
        
        const form = new FormData();
        form.append('date', date_send);
        form.append('time', time);
        form.append('driver_id', driverId);
        form.append('schedule_id', selectedSchedule.schedule_id);
        form.append('branch_id', selectedSchedule.branch_id);
        
        await axios.post(ENDPOINT + 'print-pdf-driver-binnacle', form, { responseType: "blob" })
            .then((response) => {
                const url = window.URL.createObjectURL(response.data);
                window.open(url, '_blank');
                setLoading(false);
            }).catch(function (error) {
                setLoading(false);
                Swal.fire({
                    icon: 'error',
                    title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                    showConfirmButton: true,
                    html: '<div class="text-custom-alert">No hay datos para generar el reporte</div>',
                    showClass: { popup: 'animate__animated animate__fadeInDown' },
                    hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                });
            });
    };

    return (
        <>
            {loading && <Loader />}

            <div className="container-fluid">
                <ContentHeader title="Bitácora del Conductor" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-person-badge me-2"></i> Mis Viajes Asignados
                                </h4>
                                {driverId && (
                                    <small className="text-muted">
                                        Conductor: {driverName} (ID: {driverId})
                                    </small>
                                )}
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        {!driverId ? (
                            <div className="alert alert-warning">
                                <i className="bi bi-exclamation-triangle me-2"></i>
                                No se pudo identificar al conductor. Por favor, inicie sesión nuevamente.
                            </div>
                        ) : (
                            <>
                                <div className="indications row mb-4">
                                    <div className="col-md-3 col-sm-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="date" className="col-form-label col-form-label-sm">
                                                Fecha 
                                            </label>
                                            <br/>
                                            <DatePicker
                                                showIcon
                                                locale="es"
                                                selected={date}
                                                onChange={(date) => setDate(date)}
                                                onCalendarClose={handleCalendarClose}
                                                className="form-control form-control-sm"
                                                icon="fa fa-calendar"
                                                required
                                                dateFormat="dd, MMMM, yyyy"
                                            />
                                            <small className="binnacle-field-hint">Seleccione la fecha del viaje</small>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-sm-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="time" className="col-form-label col-form-label-sm">
                                                Hora - Sucursal
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="time"
                                                name="time"
                                                required
                                            >
                                                <option selected value="">Seleccione horario</option>
                                                {times.map((item, index) => (
                                                    <option key={index} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="binnacle-field-hint">Seleccione la hora y sucursal del viaje</small>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-sm-6 mb-3" style={{ display: "flex", justifyContent: 'start', alignItems: "center" }}>
                                        <button
                                            onClick={() => handleSearch()}
                                            className="btn btn-primary btn-sm me-1">
                                            <i className="fa fa-search me-1"></i> Buscar Viajes
                                        </button>
                                        <button
                                            onClick={() => handlePrint()}
                                            className="btn btn-success btn-sm">
                                            <i className="fa fa-print me-1"></i> Imprimir
                                        </button>
                                    </div>
                                </div>
                                
                                <div className="alert alert-info">
                                    <i className="bi bi-info-circle me-2"></i>
                                    Esta bitácora muestra solo los viajes asignados a {driverName}.
                                </div>
                                
                                <table className="table table-hover main table-striped">
                                    <thead>
                                        <tr>
                                            <th width="10%" className="text-center">Asiento</th>
                                            <th width="28%" className="text-left">Pasajero</th>
                                            <th width="20%" className="text-left">Donde Sube</th>
                                            <th width="11%" className="text-left">Origen</th>
                                            <th width="11%" className="text-left">Destino</th>
                                            
                                            <th width="10%" className="text-center">Folio</th>
                                            <th width="10%" className="text-center">Taquillero</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {binnacles.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    {item.seat}
                                                </td>
                                                <td>
                                                    {item.name} {item.last_name}
                                                </td>
                                                <td>
                                                    {item.where_up}
                                                </td>
                                                <td>
                                                    {item.origin?.name}
                                                </td>
                                                <td>
                                                    {item.destination?.name}
                                                </td>
                                                
                                                <td className="text-center">
                                                    {item.invoice}
                                                </td>
                                                <td className="text-center">
                                                    {item.name_user}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default DriverBinnacle;